import { getProductBasedOfferIdsWithMandatorySku } from 'pricing-pages-lib/utils/productBasedOfferUtils';
import { createDTBConfigPublic } from 'self-service-api/core/api/dtbApi';
import { MONTHLY_COMMIT_MONTHLY_PAY } from 'self-service-api/constants/DTBOfferTerms';
import { getPricingLibState, getProductConfigsForCrmStarter } from './getPriceByTier';
export const getDtbIdForAcq129PurchaseFlow = state => {
  const pricingLibState = getPricingLibState(state['pricing']);
  const productConfigurations = getProductConfigsForCrmStarter(pricingLibState);
  const skuIds = productConfigurations.map(({
    skuId
  }) => skuId);
  const productBasedOfferIds = getProductBasedOfferIdsWithMandatorySku(pricingLibState, {
    skuIds
  });
  const currencyCode = pricingLibState.currencyCode;
  return createDTBConfigPublic({
    offerTerms: [MONTHLY_COMMIT_MONTHLY_PAY],
    productConfigurations,
    currencyCode,
    productBasedOfferIds
  });
};